var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#f2f2f2;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#000;stroke-linecap:round;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-8{stroke-width:5px;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-8{fill:none;}.cls-3{fill:#668bff;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-linejoin:round;}.cls-4{stroke-width:6.12px;}.cls-5{stroke-width:7.09px;}.cls-6{stroke-width:5.21px;}.cls-7{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1107,1199.44H522.31c-15.57.78-30.83.71-45.52,0H93c6.54-51.85,36.24-111.25,36.24-111.25s.11-.14.34-.4C137,1079.4,261.91,942,498.23,924.31c20.15-1.51,41.11-2.14,62.88-1.75q7.51.13,15.41.4c24.72.83,52,2.59,80.42,5.19,85.7,7.8,182.7,23.1,256.88,43,40.82,10.94,74.74,23.25,96,36.45,10.41,6.45,19.86,15.11,28.41,25.28C1078.93,1081.07,1099.46,1162.8,1107,1199.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1051.76,1020.7c-4.07,3.86-8.55,7.9-13.49,12.14-1.15,1-2.34,2-3.55,3,0,0-79.75,100.05-231.76,163.59H522.31c-15.57.78-30.83.71-45.52,0h-206c-70.05-30.77-118.1-71.6-141.17-111.65-17.24-29.93-20.53-59.4-8.63-83.92,4.75-9.78,108-74,110.58-86.77,11.39-57,4-137.14,4-181.25V580.49c0-162.75,123.35-302.3,297.35-302.3,337.71,0,409.67,513.23,409.67,513.23a143,143,0,0,0,1.93,23.84C966.21,943.81,1162.28,916,1051.76,1020.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 325.78,
    y: 407.64,
    width: 415.66,
    height: 519.33,
    rx: 207.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M943.34,792.18c3,32,10.66,216.26-127.93,275.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689,1148.07c-51.33,34.84-111,48.58-166.7,51.37-15.57.78-30.83.71-45.52,0-63.7-3.08-116.52-18.09-136.53-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293,798.27c1.52,27.42,2,132.7-36.55,158.39-22.85,15.23-71.58,47.21-82.24,64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.11,775.43c-16.75,57.87-48.74,138.59-134,164.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M660.07,426.67c-12.18,1.53-51.78-6.09-38.07-32s32,3.05,45.68,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M669.23,434c2.14,12.09,21.09,47.68,41.79,27s-14.7-32.12-34.75-40.28l-7,13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 667.55,
    cy: 423.77,
    r: 10.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.45,563.74c-25.12-38.07-80-147.73-207.88-140.11s-187.32,103.56-201,176.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 346.34,
    y1: 628.42,
    x2: 325.78,
    y2: 628.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 740.79,
    y1: 628.42,
    x2: 724.8,
    y2: 628.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.53,457.89c-31.08,21.28-50.72,58.34-50.89,96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.92,524.25a153.09,153.09,0,0,1,15.77,89.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M815.54,518a149.16,149.16,0,0,1,46,69.63c6.4,20.8,8.14,42.71,12.4,64s11.55,43,26.78,58.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M909.71,789.27c1.87,15,3.74,30.33,1.06,45.24-1.83,10.19-5.74,19.88-8.69,29.82a163.94,163.94,0,0,0-4,76.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M504.73,633.8a79.2,79.2,0,0,1-158.39,0c0-43.74,35.46-70.06,79.2-70.06S504.73,590.06,504.73,633.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M725.56,633.8a79.2,79.2,0,0,1-158.39,0c0-43.74,35.46-70.06,79.19-70.06S725.56,590.06,725.56,633.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M690.08,600.5c-24.57-28.35-54.17-32.76-87.66-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.6,600.5c24.56-28.35,54.16-32.76,87.65-9.64"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.23,
    cy: 624.66,
    rx: 15.23,
    ry: 22.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.58,
    cy: 624.66,
    rx: 15.23,
    ry: 22.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.7,640.71c0-24.68,62.5-24.68,62.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M478.84,775.43c6.09,65.49,123.36,57.87,132.5,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 685.02,
    y1: 718.77,
    x2: 705.17,
    y2: 708.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 688.69,
    y1: 737.08,
    x2: 702.13,
    y2: 727.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 405.77,
    y1: 730.95,
    x2: 385.63,
    y2: 720.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 388.4,
    y1: 746.22,
    x2: 374.97,
    y2: 736.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M649.74,611.88c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M641,608.13c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M415.79,611.88c-4.8.12-14.8-6.13-14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M424.54,608.13c-4.8.12-14.8-6.13-14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M536.26,668.62a28.75,28.75,0,0,0,0,57.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar06);
export default __webpack_public_path__ + "static/media/Avatar-06.b4a57acd16da76e2d722ee972ce34864.svg";
export { ForwardRef as ReactComponent };